import React, { useState } from "react";
import FaqDropdown from "./FaqDropdwon";
import Button from "components/dashboard/forms/button/Button";
import Layout from "partials/layout";

export const Faq = () => {
  const faqs = [
    {
      id: 1,
      question: "What is the Lagos State Education Resource Center?",
      answer:
        "The Lagos State Education Resource Center is a comprehensive online platform aimed at providing educational resources and support to students, teachers, and the community at large. Established in 1967, the Lagos State Education Resource Centre features a library and ICT laboratory for internet access, educational material downloads, exam registration, result checks, and instructional material creation.",
    },
    {
      id: 2,
      question: "How do I create an account on the ERC web app?",
      answer:
        "To create an account, click on the “Sign Up” button on the homepage, fill in the required details, and submit the form. You will receive an OTP via email to verify your account. Once verified, you can log in and access the platform’s features.",
    },
    {
      id: 3,
      question: "What can I find in the 'Tour Lagos' section?",
      answer:
        "The “Tour Lagos” section provides an interactive gallery showcasing the cultural, historical, and educational landmarks across Lagos State. It’s designed to enrich learning and inspire exploration of the state’s heritage.",
    },
    {
      id: 4,
      question:
        "How can I enroll in a course?",
      answer:
        "To enroll, log in to your account, browse the available courses in the “Courses” section, and select the one you’re interested in. Follow the prompts to complete the enrollment process. Some courses may have associated fees, which can be paid online."

    },
    {
      id: 5,
      question:
        "What should I do if I encounter a technical issue?",
      answer:
        "	If you experience any issues, please contact our support team via the 'Support' tab. Provide a brief description of the problem, and our team will assist you as quickly as possible.",
    },
    {
      id: 6,
      question:
        "Can I track my application status?",
      answer:
        "Yes, you can track your application status by logging in to your account and navigating to the “Applicants” tab. Here, you’ll find updates on your application’s progress, including any pending document submissions or approvals.",
    },
  ];
  const statuses = ["latest", "last seen", "frequent"];
  const [faqStatus, setFaqStatus] = useState("latest");
  const filteredFaq =
    faqStatus === "latest"
      ? faqs
      : faqs.filter((item) => item.status === faqStatus);
  return (
<Layout>
<div className="md:p-24 p-6 flex flex-col gap-12  text-[#1D2026] ">
      <h1 className="font-ManropeSemibold md:text-[40px]  text-[24px] leading-10">
        Frequently asked questions
      </h1>
      <main className="flex md:flex-row flex-col gap-6">
        <div className="md:w-1/4 w-full">
          <div className="w-full shadow-lg">
            {statuses.map((status) => (
              <button
                className={`px-6 py-4 w-full text-[16px] text-start text-secondary font-ManropeSemibold leading-[24px] capitalize  ${
                  status === faqStatus
                    ? "transition-all duration-100 bg-primary "
                    : "bg-white"
                }`}
                key={status}
                onClick={() => setFaqStatus(status)}
              >
                {status}
              </button>
            ))}
          </div>
        </div>
        <div className="md:w-2/4 w-full flex flex-col gap-6">
          {filteredFaq.map((data) => (
            <FaqDropdown
              key={data.id}
              smallText={data.answer}
              header={data.question}
            />
          ))}
        </div>
        <div className="md:w-1/4 w-full bg-[#F5F7FA] h-fit flex flex-col gap-2 p-4">
            <div className="flex flex-col gap-4">
                <h2 className="text-[#1D2026] font-ManropeSemibold md:text-[18px] leading-5">Don't find your answer!</h2>
                <p className="text-[#6E7485] font-ManropeLight md:text-[12px]leading-4">Don't worry, write your question here and our support team will help you.</p>
            </div>
            <form action="" className="flex flex-col gap-4">
                <input type="text" className="bg-white py-3 px-2 border-none w-full outline-none" placeholder="Subject" />
                <textarea name="" id="" cols="30" rows="10" className="bg-white px-2 py-3 border-none outline-none w-full" placeholder="Message" />
                <Button className="bg-primary font-inter font-ManropeSemibold w-fit px-4 md:text-[14px] text-secondary rounded-sm py-2" onClick={'#'}>
                Submit question
                </Button>
            </form>
        </div>
      </main>
    </div>
</Layout>
  );
};
